module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921093834_T.eae298e8.jpg";